import React from 'react';
import ConnectedProjectList from '../containers/ConnectedProjectList';
import { ProjectType } from '../domain/Project';

const AllEvents: React.FC = () => {
  return (
    <>
      <ConnectedProjectList filters={{ type: ProjectType.EVENT }} />
    </>
  );
};

export default AllEvents;
